// extracted by mini-css-extract-plugin
module.exports = {"root":"steps-compact-module_root_1zLwj","progressStep":"steps-compact-module_progressStep_27SP6"};